import api from '@/api'
import { setStorageSync, notifyAuthenticated } from '@/utils/uni-app'
export async function accountRequest(method, url, data) {
  const result = await api({ method, url: '/liner/auth/' + url, data, timeout: 30000 })
  if (Number(result.code) !== 200) throw new Error(result.msg || '操作失败，请重试')
  return result.data
}
export function saveAccountSession(data) {
  setStorageSync('token', data.token)
  setStorageSync('username', data.username)
  notifyAuthenticated()
}
export function accountError(error) { return error.response?.data?.msg || error.message || '网络异常，请稍后重试' }
export function validContact(channel, value) {
  return channel === 'phone' ? /^1[3-9]\d{9}$/.test(value.trim()) : /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())
}
